import {
  NOTIFICATION,
  NOTIFICATION_SUCCESSFUL,
  NOTIFICATION_FAILED,
  UPDATE_NOTIFICATION,
  UPDATE_NOTIFICATION_SUCCESSFUL,
  UPDATE_NOTIFICATION_FAILED
} from "./actionTypes"

export const getNotification = pageNumber => {
  return {
    type: NOTIFICATION,
    payload: {pageNumber}
  }
}

export const notificationSuccessful = notifications => {
  return {
    type: NOTIFICATION_SUCCESSFUL,
    payload: {notifications},
  }
}

export const notificationFailed = errorMessage => {
  return {
    type: NOTIFICATION_FAILED,
    payload: {errorMessage}
  }
}
export const updateNotification = ids => {
  return {
    type: UPDATE_NOTIFICATION,
    payload: {ids}
  }
}
export const updateNotificationSuccessful = successMessage => {
  return {
    type: UPDATE_NOTIFICATION_SUCCESSFUL,
    payload: {successMessage},
  }
}

export const updateNotificationFailed = errorMessage => {
  return {
    type: UPDATE_NOTIFICATION_FAILED,
    payload: {errorMessage},
  }
}
